import {LabelWithoutJson} from '@/components/atoms'
import {AccordionCustom as Accordion} from '@/components/molecules/AccordionCustom'
import {AccordionItemCustom as AccordionItem} from '@/components/molecules/AccordionItemCustom'
import {PageContainer} from '@/components/organisms'
import {useAllSegments} from '@/hooks/useAllSegments'
import {useFeatureFlagLanguages} from '@/hooks/useFeatureFlagLanguages'
import {getSegmentsDatafromSegmentsIds} from '@/utils/commons'
import {COLOR_CODE} from '@/utils/constants/colors'
import {FONT_WEIGHT} from '@/utils/constants/globalStyle'

const BaseData = ({productData}) => {
  const languages = useFeatureFlagLanguages()
  const {allSegments} = useAllSegments()

  const selectedSegments = getSegmentsDatafromSegmentsIds(productData?.baseData?.segments, allSegments)

  const segmentsValue = selectedSegments && selectedSegments.map(seg => seg.name).join(', ')

  const LabelWithVal = ({keyName, val}) => {
    const id = keyName?.toLowerCase()?.replaceAll(' ', '_') ?? ''
    return (
      <div className="col-4 pt-5">
        <div className="w-49">
          <LabelWithoutJson id={`${id}_label`} text={keyName} />
        </div>
        <div className="w-49">
          <LabelWithoutJson
            id={`${id}_value`}
            text={val}
            isValueDiasbledInput={false}
            fontWeight={FONT_WEIGHT.BOLD}
            color={COLOR_CODE._FFFFFF}
          />
        </div>
      </div>
    )
  }
  const LanguageGrid = ({title, data}) => (
    <div className="grid grid-cols-3 gap-4 pb-5">
      <LabelWithVal keyName={`${title} Id`} val={data?.id || '-'} />

      {languages.map(lang => (
        <div key={lang.code}>
          <div className="language-wrapper pt-5">
            <span>Language:</span> {lang.language}
          </div>
          <LabelWithVal keyName={title} val={data?.[lang.code] || '-'} />
        </div>
      ))}
    </div>
  )

  return (
    <>
      <PageContainer>
        <div className="productoverview-basedata">
          {/* Product information Content */}
          <div className="sc-border heading mt-[29px] pb-5 text-base font-bold">Product Information</div>
          <div className="sc-border grid grid-cols-3 gap-4 pb-5">
            <LabelWithVal keyName="Product Size" val={productData?.baseData?.productSize || '-'} />
            <LabelWithVal keyName="Product Type" val={productData?.baseData?.productType || '-'} />

            <LabelWithVal
              keyName="Store Segment(s)"
              val={productData?.baseData?.segments?.length > 0 ? segmentsValue : '-'}
            />

            <LabelWithVal keyName="SKU Number" val={productData?.baseData?.skuNumber || '-'} />
            <LabelWithVal keyName="Bar Code" val={productData?.baseData?.barCode || '-'} />
            <LabelWithVal keyName="Route Type ID" val={productData?.baseData?.routeTypeId || '-'} />
            <LabelWithVal keyName="Product Line" val={productData?.baseData?.productLine || '-'} />
            <LabelWithVal keyName="Product Group" val={productData?.baseData?.productGroup || '-'} />
            <LabelWithVal keyName="Product Container" val={productData?.baseData?.productContainer || '-'} />
            <LabelWithVal keyName="Sale Unit Name" val={productData?.baseData?.saleUom || '-'} />
            <LabelWithVal
              keyName="Multiple Selling Units"
              val={productData?.additionalInfo?.allowedInMultiplesOf || '-'}
            />
            <LabelWithVal
              keyName="Suggested Product Selling Price"
              val={productData?.additionalInfo?.suggestedSellingPrice || '-'}
            />

            <LabelWithVal keyName="Sorting" val={productData?.baseData?.sorting || '-'} />
            <LabelWithVal
              keyName="Show on e-commerce"
              val={
                productData?.baseData?.showOnEcommerce === true || productData?.baseData?.showOnEcommerce === 'true'
                  ? 'Yes'
                  : 'No'
              }
            />
            <LabelWithVal
              keyName="Show on engagement "
              val={
                productData?.baseData?.showOnEngagement === true || productData?.baseData?.showOnEngagement === 'true'
                  ? 'Yes'
                  : 'No'
              }
            />
          </div>
          <div>
            {/* Product Description */}
            <div className="grid grid-cols-3 gap-4 pb-5">
              {languages.map(lang => (
                <div key={lang.code}>
                  <div className="language-wrapper pt-5">
                    <span>Language:</span> {lang.language}
                  </div>
                  <LabelWithVal
                    keyName="Product Description"
                    val={productData?.baseData?.productDescription?.[lang.code] || '-'}
                  />
                </div>
              ))}
            </div>

            {/* Product Size */}
            <LanguageGrid
              title="Display Product Size"
              data={{
                id: productData?.baseData?.sizeId,
                ...productData?.baseData?.sizeByLocale,
              }}
            />

            {/* Product Type */}
            <LanguageGrid
              title="Display Product Type"
              data={{
                id: productData?.baseData?.productTypeId,
                ...productData?.baseData?.productTypeByLocale,
              }}
            />
          </div>

          {/* Category Content */}
          <div className="sc-border heading mt-[29px] pb-5 text-base font-bold">Returns & Deposits</div>
          <div className="grid grid-cols-3 gap-4 pb-5">
            <LabelWithVal
              keyName="Returnable"
              val={
                productData?.baseData?.isReturnable === true || productData?.baseData?.isReturnable === 'true'
                  ? 'Yes'
                  : 'No'
              }
            />
            <LabelWithVal
              keyName="Depositable"
              val={
                productData?.baseData?.isDepositable === true || productData?.baseData?.isDepositable === 'true'
                  ? 'Yes'
                  : 'No'
              }
            />
          </div>
          <div className="sc-border grid grid-cols-1 gap-4 pb-5">
            <LabelWithVal keyName="Description" val={productData?.baseData?.description || '-'} />
            <LabelWithVal keyName="Business Description" val={productData?.baseData?.businessDescription || '-'} />
          </div>
        </div>
      </PageContainer>
      <div className="basedata-accordion-content-wrapper">
        <Accordion
          isDark
          size="large"
          content={
            <AccordionItem
              isDark
              expanded
              size="large"
              label={<div className="sc-border heading pb-5 text-base font-bold">Additional Information</div>}
              presentation="test"
              content={
                <>
                  <div className="productoverview-basedata">
                    <div className="sc-border grid grid-cols-3 gap-4 pb-5">
                      <LabelWithVal
                        keyName="Product Size"
                        val={productData?.additionalInfo?.displayProductSize || '-'}
                      />
                      <LabelWithVal keyName="Product Code 2" val={productData?.additionalInfo?.productCode2 || '-'} />
                      <LabelWithVal keyName="GMTU" val={productData?.additionalInfo?.gtmuId || '-'} />
                      <LabelWithVal keyName="Sale Org" val={productData?.additionalInfo?.salesOrg || '-'} />
                      <LabelWithVal keyName="Package Name" val={productData?.additionalInfo?.packageName || '-'} />
                      <LabelWithVal keyName="Package" val={productData?.additionalInfo?.packageCode || '-'} />
                      <LabelWithVal
                        keyName="Distribution Channel"
                        val={productData?.additionalInfo?.distributionChannel || '-'}
                      />
                      <LabelWithVal keyName="Display Order" val={productData?.additionalInfo?.displayOrder || '-'} />
                      <LabelWithVal
                        keyName="Minimum Order Quantity"
                        val={productData?.additionalInfo?.minimumOrderQuantity || '-'}
                      />
                      <LabelWithVal
                        keyName="Maximum Order Quantity"
                        val={productData?.additionalInfo?.maximumOrderQuantity || '-'}
                      />
                      <LabelWithVal
                        keyName="Unit Multiplier"
                        val={productData?.additionalInfo?.unitMultiplier || '-'}
                      />
                      <LabelWithVal keyName="Wishlist" val={productData?.additionalInfo?.wishlist || '-'} />
                      <LabelWithVal keyName="Reward Points" val={productData?.additionalInfo?.rewardPoints || '-'} />
                      <LabelWithVal
                        keyName="Return Price for Base Unit"
                        val={productData?.additionalInfo?.returnPriceForBaseUnit || '-'}
                      />
                      <LabelWithVal
                        keyName="Sale Unit Conversion to Base"
                        val={productData?.additionalInfo?.saleUnitConversionToBase || '-'}
                      />
                    </div>
                  </div>
                </>
              }
            />
          }
        />
      </div>
    </>
  )
}

export default BaseData
